import { ButtonGroup, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Toggle group for data types.
 * @param {Object} props
 * @param {Array<string>} props.dataTypes - List of data types
 * @param {Object} props.seriesVisibility - Map of series ID to visibility
 * @param {Function} props.onToggle - Callback when a data type is toggled
 * @param {Function} props.getIdsForDataType - Function to get series IDs for a data type
 */
const DataTypeToggleGroup = ({
  dataTypes,
  seriesVisibility,
  onToggle,
  getIdsForDataType,
}) => {
  const { t } = useTranslation('view-data');
  return (
    <ButtonGroup>
      {dataTypes.map((dt) => {
        const idsForDt = getIdsForDataType(dt);
        const anyVisible = idsForDt.some(
          (id) => seriesVisibility[id]?.visible !== false,
        );
        return (
          <Button
            key={dt}
            variant={anyVisible ? 'contained' : 'outlined'}
            color={anyVisible ? 'primary' : 'inherit'}
            onClick={() => onToggle(dt)}
          >
            {t(`datatype.${dt}`) || dt}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default DataTypeToggleGroup;
